import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {AgentIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useRef} from 'react'
import {clsx} from 'clsx'

import {DockedPanel, useDockedPanelActions, useIsDockedPanelOpen} from '../../contexts/DockedPanelContext'
import {usePullRequestAnalytics} from '../../hooks/use-pull-request-analytics'

export interface OpenAgentsSidePanelButtonProps {
  className?: string
  size?: 'small' | 'medium'
}

export const ICON_BUTTON_LABELS = {
  open: 'Open agent sessions',
  close: 'Close agent sessions',
} as const

export function OpenAgentsPanelButton({className, size = 'small'}: OpenAgentsSidePanelButtonProps) {
  const isDockedPanelOpen = useIsDockedPanelOpen(DockedPanel.AgentSessions)
  const toggleSidePanelRef = useRef<HTMLButtonElement>(null)
  const actions = useDockedPanelActions()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  const iconButtonLabel = isDockedPanelOpen ? ICON_BUTTON_LABELS.close : ICON_BUTTON_LABELS.open

  return (
    <div className={clsx('d-flex flex-items-center', className)}>
      <ErrorBoundary
        boundaryName="OpenAgentsSidePanelButton"
        fallback={
          <IconButton
            inactive
            aria-label="The agent sessions panel cannot currently be opened."
            icon={AgentIcon}
            size={size}
            variant="invisible"
          />
        }
      >
        <IconButton
          ref={toggleSidePanelRef}
          aria-label={iconButtonLabel}
          icon={AgentIcon}
          size={size}
          variant="invisible"
          onClick={() => {
            sendPullRequestAnalyticsEvent('agent_sessions_side_panel.open', 'AGENT_SESSIONS_SIDE_PANEL_BUTTON')
            actions.togglePanel('agentSessions', {returnFocusTo: toggleSidePanelRef.current})
          }}
        />
      </ErrorBoundary>
    </div>
  )
}
